module.exports = function(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this, args = arguments;

    if (immediate.is) {
      clearTimeout(timeout);
      func.apply(context, args);
      return;
    }

    var later = function() {
      timeout = null;
      if (!immediate.is) func.apply(context, args);
    };
    var callNow = immediate.is && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};
